<template>
  <el-row class="right-panel">
    <div v-if="type === 'details'">
      <el-row class="details-section">
        <div class="header">
          <img class="img-icon" src="@/assets/settings/exclamation.svg" />
          <p class="captalize">{{ $t("User_information") }}</p>
        </div>
        <div class="text-container">
          <div
            v-for="(field, key) in userFields"
            :key="key"
            style="display: flex; margin-bottom: 20px"
          >
            <p style="width: 200px; color: #6C7B8A">{{ $t(field) }}</p>
            <p
              style="color: #1f2041;"
              v-if="key === 'country' || key === 'timezone'"
            >
              {{ data[key] ? data[key].name : "" }}
            </p>
            <p style="color: #1f2041;" v-else>{{ data[key] }}</p>
          </div>
        </div>
      </el-row>

      <el-row v-if="showPermissions(data.user_type)" class="details-section">
        <div class="header">
          <img class="img-icon" src="@/assets/settings/shield.svg" />
          <p>Permissions</p>
        </div>
        <el-row class="permissions-checkbox-container text-container">
          <div
            v-for="(newPermission, key1) in permissionsObj"
            :key="key1"
            class="permissions-checkbox-row"
          >
            <el-col :span="8">
              <p style="width: 200px; color: #6C7B8A">
                {{ newPermission.name }}
              </p>
            </el-col>
            <el-col :span="16">
              <el-checkbox-group
                :value="checkedPermissionsNew[newPermission.key]"
                :key="newPermission.name"
              >
                <el-checkbox
                  v-for="(permission,
                  actionName) in newPermission.allowedActions"
                  :label="permission"
                  :key="`${newPermission.name} ${actionName}`"
                  >{{ getLabel(actionName) }}</el-checkbox
                >
              </el-checkbox-group>
            </el-col>
            <!-- <p>{{ newPermission.name }}</p> -->
          </div>
        </el-row>
      </el-row>
      <el-row v-if="enableLocations" class="details-section">
        <el-row class="location-row">
          <div class="header">
            <img class="img-icon" src="@/assets/settings/shield.svg" />
            <p>Locations</p>
          </div>
          <el-row class="text-container">
            <el-checkbox-group v-model="checkedLocations">
              <template v-for="location in locations">
                <el-checkbox
                  :key="location._id"
                  :label="location._id"
                  disabled
                  >{{ location.name }}</el-checkbox
                >
              </template>
            </el-checkbox-group>
          </el-row>
        </el-row>
      </el-row>
    </div>
    <div v-else-if="type === 'userAccessMgmtCreate'" style="padding-top: 30px;">
      <userAccessMgmtCreate :user_details="getNewUser" v-on="$listeners" />
    </div>
    <div v-else-if="type === 'userAccessMgmtEdit'" style="padding-top: 30px;">
      <userAccessMgmtEdit :user_details="data" v-on="$listeners" />
    </div>
    <div v-else>
      <userAccessMgmtUpdatePassword
        :user_details="data"
        style="padding-top: 30px;"
      />
    </div>
  </el-row>
</template>

<script>
import userAccessMgmtCreate from "./userAccessMgmtCreate";
import userAccessMgmtEdit from "./userAccessMgmtEdit";
import userAccessMgmtUpdatePassword from "./userAccessMgmtUpdatePassword";

import User from "@/model/user";

export default {
  name: "UserDetails",
  props: {
    type: {
      default: "details"
    },
    loading: {
      default: true
    },
    data: {
      default: () => {}
    }
  },
  components: {
    userAccessMgmtCreate,
    userAccessMgmtEdit,
    userAccessMgmtUpdatePassword
  },
  data: function() {
    return {
      userFields: {
        first_name: "Usrs_first_name",
        last_name: "Usrs_last_name",
        phone: "Comn_mobile_num",
        email: "Comn_email",
        country: "Comn_country",
        timezone: "Comn_timezone"
      },
      checkedPermissionsNew: {
        MANAGE_MEDICINE: [],
        MANAGE_CULTURE: [],
        MANAGE_HARVEST: [],
        MANAGE_ABW: [],
        MANAGE_OVERVIEW: [],
        MANAGE_DEVICES: [],
        MANAGE_SCHEDULES: [],
        MANAGE_LAB_TESTS: [],
        MANAGE_STOCK: []
      },
      isIndeterminateLocations: true,
      checkAllLocations: false,
      checkedLocations: []
    };
  },
  created() {
    console.log(this.checkedPermissionsNew);
    Object.entries(this.checkedPermissionsNew).forEach(([key, value]) => {
      Object.values(this.permissionsObj[key].allowedActions).forEach(item => {
        if (this.isChecked(item)) {
          this.checkedPermissionsNew[key].push(item);
        }
      });
    });
    this.checkedLocations = this.data.allowed_locations;
  },
  computed: {
    locations() {
      return this.$store.getters["user/getUserLocations"];
    },
    locationIds() {
      return this.locations.map(location => location._id);
    },
    getNewUser() {
      return new User();
    },
    enableLocations: function() {
      return (
        ["POND_WORKER", "POND_TECHNICIAN", "POND_MANAGER", ""].indexOf(
          this.data.user_type
        ) > -1
      );
    }
  },
  methods: {
    getLabel(permission) {
      if (permission === "view") {
        return this.$t("Comn_view");
      } else if (permission === "update") {
        return this.$t("Comn_update");
      } else {
        return this.$t("Comn_delete");
      }
    },
    showPermissions(type) {
      if (
        type === "POND_OWNER" ||
        type === "POND_MANAGER" ||
        type === "ADMIN" ||
        type === "NO_ACCESS"
      ) {
        return false;
      } else if (!type) {
        return false;
      } else {
        return true;
      }
    },
    isChecked(list) {
      let allPresent = true;
      if (!this.data.permissions) {
        return "";
      }
      list.forEach(item => {
        if (this.data.permissions.includes(item)) {
        } else {
          allPresent = false;
        }
      });
      return allPresent;
    },
    areAllChecked() {
      // const totalPermissions = Object.values(
      //   Object.values(this.permissionsObj).allowedActions
      // );
      let totalPermissions = 0;
      let totalCurrentPermissions = 0;
      // return totalPermissions;
      Object.values(this.permissionsObj).forEach(({ allowedActions }) => {
        totalPermissions += Object.values(allowedActions).flat(2).length;
      });

      Object.values(this.checkedPermissionsNew).forEach(permission => {
        permission.forEach(item => {
          totalCurrentPermissions += item.length;
        });
      });

      return totalPermissions === totalCurrentPermissions;
    },
    isEmpty(value) {
      if (value == null) return true;
      const type =
        value != null && typeof value === "object"
          ? Array.isArray(value)
            ? "array"
            : "object"
          : typeof value;
      switch (type) {
        case "undefined":
          return true;
        case "string":
          return value === "";
        case "array":
          return value.length === 0;
        case "object":
          return Object.keys(value) === 0;
        default:
          console.error("Pondlogs*****Type UnKnown " + value);
      }
    }
  }
};
</script>

<style lang="scss">
.right-panel {
  padding-bottom: 20px;
  .el-checkbox__label {
    @include responsiveProperty(
      font-size,
      $app_font_size_small,
      $app_font_size_1,
      $app_font_size_2,
      true
    );
    text-transform: capitalize;
  }
  .details-section {
    padding-top: 20px;
    padding-left: 40px;
    padding-right: 40px;
    .text-container {
      @include responsiveProperty(
        font-size,
        $app_font_size_small,
        $app_font_size_1,
        $app_font_size_2
      );
    }
    .permissions-checkbox-container {
      .el-checkbox {
        opacity: 0.7;
        input {
          pointer-events: none;
        }
      }
      .permissions-checkbox-row {
        .el-checkbox__input.is_focus {
          border-color: #dcdfe6 !important;
        }
        .el-checkbox__inner:hover {
          border-color: #dcdfe6 !important;
        }
      }
    }
  }
  .location-row {
  }
  .header {
    align-items: center;
    display: flex;
    padding-bottom: 20px;
    color: #1f2041;
    img {
      margin-right: 11px;
    }
  }
}
</style>
